<app-aumico-layout>
    <ng-container header>
        <aum-action-header
            class="no-space"
            [breadcrumbItems]="breadcrumbItems"
            [hasBackButton]="false"
            [pageHeader]="pageHeader"
        >
        </aum-action-header>
    </ng-container>
    <ng-container content>
        <div class="content-wrapper">
            <div class="closing-process-description">
                <h1>{{ 'aumico_reports_fcp_enable_title' | i18next }}</h1>
                <p>{{ 'aumico_reports_fcp_enable_subtitle' | i18next }}</p>

                <div class="teasers">
                    <div class="teaser-box">
                        <span
                            hamIconShapes
                            icon="assets/hamIcons/user-settings-outline.svg"
                            [variant]="'green'"
                            [size]="'lg'"
                            [type]="'circle'"
                        ></span>

                        <h3>{{ 'aumico_reports_fcp_teaser_1_title' | i18next }}</h3>
                        <p>{{ 'aumico_reports_fcp_teaser_1_text' | i18next }}</p>
                    </div>
                    <div class="teaser-box">
                        <span
                            hamIconShapes
                            icon="assets/hamIcons/chart-line-down-outline.svg"
                            [variant]="'purple'"
                            [size]="'lg'"
                            [type]="'circle'"
                        ></span>
                        <h3>{{ 'aumico_reports_fcp_teaser_2_title' | i18next }}</h3>
                        <p>{{ 'aumico_reports_fcp_teaser_2_text' | i18next }}</p>
                    </div>
                    <div class="teaser-box">
                        <span
                            hamIconShapes
                            icon="assets/hamIcons/shield-check.svg"
                            [variant]="'pink'"
                            [size]="'lg'"
                            [type]="'circle'"
                        ></span>
                        <h3>{{ 'aumico_reports_fcp_teaser_3_title' | i18next }}</h3>
                        <p>{{ 'aumico_reports_fcp_teaser_3_text' | i18next }}</p>
                    </div>
                </div>
            </div>
            <div class="closing-process-container">
                <div *ngIf="fcpActivationDetails$ | async as fcpActivationDetails; else notActivated">
                    <ng-container *ngIf="fcpActivationDetails.subscriptionState === 'waiting-approval'; else trial">
                        <ng-container
                            *ngTemplateOutlet="notActivated; context: { waitingForApproval: true }"
                        ></ng-container>
                    </ng-container>
                    <ng-template #trial>
                        <ng-container *ngIf="fcpActivationDetails.subscriptionState === 'trial'; else paid">
                            <ng-container
                                *ngTemplateOutlet="deactivationTemplate; context: { isTrial: true }"
                            ></ng-container>
                        </ng-container>
                    </ng-template>

                    <ng-template #paid>
                        <ng-container *ngIf="fcpActivationDetails.subscriptionState === 'paid'; else notActivated">
                            <ng-container
                                *ngTemplateOutlet="deactivationTemplate; context: { isTrial: false }"
                            ></ng-container>
                        </ng-container>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-container>
</app-aumico-layout>

<ng-template #notActivated let-waitingForApproval="waitingForApproval">
    <div class="closing-process-content">
        <ham-button
            *ngIf="!waitingForApproval"
            rightIcon="assets/hamIcons/rocket-outline.svg"
            (buttonClick)="activateClosingProcessTrial()"
        >
            {{ 'aumico_reports_closing_process_request_approval' | i18next }}
        </ham-button>

        <div class="approval-status" *ngIf="waitingForApproval">
            <span>{{ 'aumico_reports_closing_process_waiting_for_approval' | i18next }}</span>
            <span class="ham-icon"> <i class="hour-glass-icon"></i> </span>
        </div>

        <div class="status-information">
            <h4>{{ 'aumico_reports_fcp_beta_terms_title' | i18next }}</h4>
            <ul>
                <li class="ham-icon">
                    <i class="arrows-repeat-icon"></i>{{ 'aumico_reports_fcp_trial_terms_2' | i18next }}
                </li>
                <li class="ham-icon">
                    <i class="x-circle-icon"></i>{{ 'aumico_reports_fcp_trial_terms_3' | i18next }}
                </li>
            </ul>
        </div>
    </div>
</ng-template>

<ng-template #deactivationTemplate let-isTrial="isTrial">
    <ham-button
        *ngIf="!showDeactivationForm"
        rightIcon="assets/hamIcons/x-circle-outline.svg"
        (buttonClick)="deactivateClosingProcess()"
        variant="red"
    >
        {{ 'aumico_reports_closing_process_deactivate' | i18next }}
    </ham-button>
    <form class="deactivation-form" *ngIf="showDeactivationForm" [formGroup]="stopTrialForm">
        <h4>
          {{
            isTrial
                ? ('aumico_reports_fcp_trial_deactivation_title' | i18next)
                : ('aumico_reports_fcp_subscription_deactivation_title' | i18next)
        }}
       
        </h4>
        <p class="deactivation-text">  {{
          isTrial
              ? ('aumico_reports_fcp_trial_deactivation_text' | i18next)
              : ('aumico_reports_fcp_subscription_deactivation_text' | i18next)
      }}
        </p>
        <textarea
            [ngClass]="{
                'invalid-field': stopTrialForm.controls['survey'].invalid && stopTrialForm.controls['survey'].touched
            }"
            rows="4"
            hamInput
            formControlName="survey"
            placeholder="{{ 'aumico_reports_fcp_deactivation_placeholder' | i18next }}"
            (cancel)="cancel()"
        >
        </textarea>

        <p class="deactivation-text">{{ 'aumico_reports_fcp_deactivation_confirmation_question_text' | i18next }}</p>
        <p class="deactivation-text">
            <strong>{{ 'aumico_reports_fcp_deactivation_terms' | i18next }}</strong>
        </p>
        <ul class="deactivation-text">
            <li>{{ 'aumico_reports_fcp_deactivation_term_data_storage' | i18next }}</li>
            <li>{{ getEndDateText }}</li>
            <li>{{ 'aumico_reports_fcp_deactivation_term_costs' | i18next }}</li>
        </ul>

        <ham-button
            rightIcon="assets/hamIcons/x-circle-outline"
            variant="red"
            type="submit"
            (buttonClick)="confirmDeactivateClosingProcess()"
            >{{ 'aumico_reports_fcp_deactivation_feedback_button' | i18next }}
        </ham-button>
    </form>
  
</ng-template>

<ham-modal
    *ngIf="showActivateTrialModal"
    saveText="{{ 'aumico_confirmation_modal_activate_button' | i18next }}"
    (cancel)="onCancelActivateClosingProcessTrial()"
    (save)="onConfirmActivateClosingProcessTrial()"
    size="sm"
>
    <p>
        {{ 'aumico_confirmation_modal_activate_subscription_description' | i18next }}
    </p>
</ham-modal>

<ham-modal
    *ngIf="showCantDeactivateModal"
    saveText="{{ 'aumico_reports_cant_activate_fcp_ok' | i18next }}"
    (cancel)="onConfirmCantActivateModal()"
    (save)="onConfirmCantActivateModal()"
    size="sm"
>
    <p>
        {{ 'aumico_reports_cant_activate_fcp' | i18next }}
    </p>
</ham-modal>
